import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const FlagIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M14.456.132c-2.588 1.32-3.822.877-5.146.404C8.04.08 6.687-.404 3.975.61A15.74 15.74 0 0 0 3 1.013V12a11.9 11.9 0 0 1 1-.443c.35-.135.683-.242 1-.324 1.86-.48 3.18-.104 4.501.27 1.634.464 3.268.928 5.92-.225a.981.981 0 0 0 .579-.9V.963c0-.784-.838-1.19-1.544-.831ZM14 9.688V2.515c-.978.357-1.867.51-2.722.49-1.097-.028-2-.355-2.618-.578l-.156-.056c-.644-.229-1.094-.364-1.69-.36-.425.004-1.004.083-1.814.356v6.815a8.677 8.677 0 0 1 1.584-.174c1.325-.021 2.426.279 3.286.521l.115.033c.843.238 1.423.402 2.088.433.512.025 1.127-.032 1.927-.307ZM2 1a.999.999 0 1 0-2 0V15.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5V1Z"/>
    </svg>
);
FlagIcon.displayName = 'FlagIcon';
export default FlagIcon;
